const passwordKeys = {
    upperCase: "ABCDEFGHIJKLMNOPQRSTUVWXYZ",
    lowerCase: "abcdefghijklmnopqrstuvwxyz",
    number: "0123456789",
    symbol: "!@#$%^&*()_+~|}{[]-="
}

const lightPasswordKeys = [
    function upperCase() {
        return passwordKeys.upperCase[Math.floor(Math.random() * passwordKeys.upperCase.length)];
    },
    function lowerCase() {
        return passwordKeys.lowerCase[Math.floor(Math.random() * passwordKeys.lowerCase.length)];
    },
    function number() {
        return passwordKeys.number[Math.floor(Math.random() * passwordKeys.number.length)];
    }
];

const hardPasswordKeys = [
    ...lightPasswordKeys,
    function symbol() {
        return passwordKeys.symbol[Math.floor(Math.random() * passwordKeys.symbol.length)];
    }
]

/**
 * Генерация случайного пароля заданной длины, если установлен флаг hard то пароль также будет включать спец символы
 * @param {Number} length
 * @param {boolean} hard
 * @returns {string}
 */
export const generatePassword = (length = 12, hard = false) => {
    const passwordKeys = hard ? hardPasswordKeys : lightPasswordKeys;
    let password = "";
    while (length > password.length) {
        let keyToAdd = passwordKeys[Math.floor(Math.random() * passwordKeys.length)];
        password += keyToAdd();
    }
    return password;
};

export const passwordUtilsMixin = {
    methods: {
        generatePassword: generatePassword,
    },
};
